import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import BackgroundImage_Web from '../../../assets/images/partner/image_background_01.png';
import BackgroundImage_Mobile from '../../../assets/images/sitter/mobile/review_background.png';
import './partner.css';
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal, HorizontalPadding } from '../../common/responsive.utils';

const Component08 = ({ ...props }): React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const [slideIndex, setSlideIndex] = React.useState<number>(0);
    const [indicator, setIndicator] = React.useState<string>("indicator");
    const [paddingCheck, setPaddingCheck] = React.useState<boolean>(false);
    const styles = getStyles(paddingCheck);

    const items_Web = [

        <div style={styles.contentScreen_Web}>
            <span style={styles.contentTxt_Web}>
                {"창업한지 얼마 안 되어서 걱정이 많았는데, 고객에게"} <span style={styles.textStyBold_Web}>{"직접 제안을 보내니까 짧은 시간에 원생이 눈에 띄게 늘었어요!"}</span>
            </span>
            <span style={styles.userTxt_Web}>
                {"창업 3개월 차 유치원 원장님"}
            </span>

            <img src={BackgroundImage_Web} style={styles.backgroundImage_Web} alt="배경" />
        </div>,


        <div style={styles.contentScreen_Web}>
            <span style={styles.contentTxt_Web}>
                {"그동안 일일이 예약 관리를 해왔는데, 이제"} <span style={styles.textStyBold_Web}>{"이용권 차감도 예약 안내도 자동으로 되니 정말 편해요."}</span>
            </span>
            <span style={styles.userTxt_Web}>
                {"펫 호텔 사장님"}
            </span>

            <img src={BackgroundImage_Web} style={styles.backgroundImage_Web} alt="배경" />
        </div>,

        <div style={styles.contentScreen_Web}>
            <span style={styles.contentTxt_Web}>
                {"다른 곳에서 홍보하지 않고 우주펫에"} <span style={styles.textStyBold_Web}>{"매장 등록만 했을 뿐인데도 문의가 정말 많이 와요!"}</span>
            </span>
            <span style={styles.userTxt_Web}>
                {"온라인 홍보를 처음 해본 사장님"}
            </span>

            <img src={BackgroundImage_Web} style={styles.backgroundImage_Web} alt="배경" />
        </div>

    ];

    const items_Mobile = [
        <div style={{ paddingRight: "1.25vw" }}>
            <div style={styles.contentScreen_Mobile}>
                <span style={styles.contentTxt_Mobile}>
                    {"창업한지 얼마 안 되어서 걱정이 많았는데, 고객에게"} <span style={styles.textStyBold_Mobile}>{"직접 제안을 보내니까 짧은 시간에 원생이 눈에 띄게 늘었어요!"}</span>
                </span>
                <span style={styles.userTxt_Mobile}>
                    {"창업 3개월 차 유치원 원장님"}
                </span>
                <img src={BackgroundImage_Mobile} style={styles.backgroundImage_Mobile} alt="배경" />
            </div>
        </div>,
        <div style={{ paddingRight: "1.25vw" }}>
            <div style={styles.contentScreen_Mobile}>
                <span style={styles.contentTxt_Mobile}>
                    {"그동안 일일이 예약 관리를 해왔는데, 이제"} <span style={styles.textStyBold_Mobile}>{"이용권 차감도 예약 안내도 자동으로 되니 정말 편해요."}</span>
                </span>
                <span style={styles.userTxt_Mobile}>
                    {"펫 호텔 사장님"}
                </span>
                <img src={BackgroundImage_Mobile} style={styles.backgroundImage_Mobile} alt="배경" />
            </div>
        </div>,
        <div style={{ paddingRight: "1.25vw" }}>
            <div style={styles.contentScreen_Mobile}>
                <span style={styles.contentTxt_Mobile}>
                    {"다른 곳에서 홍보하지 않고 우주펫에"} <span style={styles.textStyBold_Mobile}>{"매장 등록만 했을 뿐인데도 문의가 정말 많이 와요!"}</span>
                </span>
                <span style={styles.userTxt_Mobile}>
                    {"온라인 홍보를 처음 해본 사장님"}
                </span>
                <img src={BackgroundImage_Mobile} style={styles.backgroundImage_Mobile} alt="배경" />
            </div>
        </div>
    ];

    const setIndexChange = (idx: number) => {
        const indexString = ["a", "b", "c"]
        const animationString = indexString[slideIndex] + indexString[idx]

        console.log(animationString)

        if (idx !== slideIndex) {
            setSlideIndex(idx)
            setIndicator(`indicator ${animationString}`)
        }
    }

    // 드래그 시작 시 패딩을 없애기
    const handleMouseDown = () => {
        if (!paddingCheck) {
            setPaddingCheck(true);
        }
    };

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.screen_Web}>
                        <span style={styles.titleTxt_Web}>
                            300개+ 매장이 우주펫 파트너와 함께하고 있어요
                        </span>

                        <div style={styles.screenRow_Web}>
                            <div style={{ width: '100%' }}>
                                <div onMouseDown={handleMouseDown} style={{ width: "100%", marginLeft: paddingCheck ? "" : "45px" }}>
                                    <AliceCarousel
                                        paddingLeft={paddingCheck ? 180 : 0}
                                        activeIndex={slideIndex}
                                        infinite={true}
                                        animationDuration={500}
                                        mouseTracking
                                        disableDotsControls
                                        disableButtonsControls
                                        items={items_Web}
                                        autoHeight
                                        autoWidth
                                        onSlideChanged={(e) => {
                                            setIndexChange(e.item)
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ height: 40 }} />

                            <div style={styles.indicatorCon_Web}>
                                <div className={indicator} />
                            </div>
                        </div>
                    </div>
                </>
                ) : (
                <>
                <div style={styles.screen_Mobile}>
                    <span style={styles.titleTxt_Mobile}>
                        300개+ 매장이 <br />
                        우주펫 파트너와 함께하고 있어요
                    </span>

                    <div style={{ height: "4.5vh" }} />

                    <AliceCarousel
                        activeIndex={slideIndex}
                        mouseTracking
                        disableDotsControls
                        disableButtonsControls
                        items={items_Mobile}
                        autoHeight
                        autoWidth
                        onSlideChanged={({ item }) => {
                            setSlideIndex(item);
                        }}
                    />

                    <div style={{ height: "4.5vh" }} />
                        <div style={styles.indicatorCon_Mobile}>
                        {[0, 1, 2].map((idx) => (
                            <div
                                key={idx}
                                style={{
                                    ...styles.indicatorItem_Mobile,
                                    backgroundColor: idx === slideIndex ? "#9F6BFF" : "#F4F4F5",
                                    transition: "background-color 0.3s ease",
                                }}
                            />
                        ))}
                    </div>
                </div>
            </>
            )}
        </>
    );
}

const getStyles = (paddingCheck: boolean): Record<string, React.CSSProperties> => ({
    screen_Web: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingBottom: responsivePaddingVertical(51, 90), paddingTop: responsivePaddingVertical(40, 90), paddingRight: responsivePaddingHorizontal(25, 88), paddingLeft: paddingCheck ? "" : " 6.1111vw", boxSizing: "border-box" },
    screenRow_Web: { display: "flex", flexDirection: "column" },
    titleTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: "-3%", alignSelf: "flex-start", lineHeight: "140%", paddingLeft: paddingCheck ? "8.3vw" : "2.2vw", paddingBottom: responsivePaddingVertical(30, 70) },
    contentScreen_Web: { width: "880px", height: "263px", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", paddingBottom: HorizontalPadding(24, 42), paddingTop: HorizontalPadding(24, 42), paddingLeft: HorizontalPadding(20, 42), paddingRight: HorizontalPadding(20, 42), backgroundColor: "transparent" },
    contentTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(15, 28), fontWeight: 400, color: "#62686D", lineHeight: "150%", paddingBottom: HorizontalPadding(24, 42), letterSpacing: "-3%", marginTop: "10px" },
    userTxt_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(12, 22), fontWeight: 400, color: "#9FA5AD", lineHeight: "140%", letterSpacing: "-3%" },
    indicatorCon_Web: { width: 136, height: 4, backgroundColor: "#F4F4F5", borderRadius: 20, marginLeft: paddingCheck ? "8.6vw" : "2.5vw" },
    backgroundImage_Web: { width: "97%", height: "263px", position: "absolute", top: 0, left: 0, zIndex: -1 },
    textStyBold_Web: { fontFamily: "'Pretendard'", fontSize: responsiveFont(15, 28), fontWeight: 600, letterSpacing: "-3%", color: "black", lineHeight: "150%" },

    screen_Mobile: { width: "100%", minWidth: "320px", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingBottom: responsivePaddingVertical(51, 120), paddingTop: responsivePaddingVertical(40, 90), paddingRight: responsivePaddingHorizontal(25, 88), paddingLeft: "7.5vw", boxSizing: "border-box" },
    titleTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(22, 40), fontWeight: 700, letterSpacing: "-3%", alignSelf: "flex-start", lineHeight: "140%", color: "black" },
    contentScreen_Mobile: { width: "calc(100vw - 15vw)", height: "191px", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start", paddingBottom: HorizontalPadding(24, 42), paddingTop: HorizontalPadding(24, 42), paddingLeft: HorizontalPadding(20, 42), paddingRight: HorizontalPadding(20, 42), backgroundColor: "transparent", position: "relative" },
    contentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(15, 28), fontWeight: 400, letterSpacing: "-3%", color: "#62686D", lineHeight: "150%",  paddingTop: 10, },
    userTxt_Mobile: { fontSize: responsiveFont(12, 22), fontWeight: 400, color: "#9FA5AD", lineHeight: "140%" },
    indicatorCon_Mobile: { width: "42.5000vw", height: "1.2500vw", backgroundColor: "#F4F4F5", borderRadius: 20, display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", padding: "0 0.5vw", boxSizing: "border-box" },
    indicatorItem_Mobile: { flex: 1, height: "1.25vw", borderRadius: "20px", margin: "0 0.2vw", transition: "background-color 0.3s ease" },
    backgroundImage_Mobile: { width: "calc(100vw - 15vw)", height: "191px", position: "absolute", top: 0, left: 0, zIndex: -1 },
    textStyBold_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(15, 28), fontWeight: 600, letterSpacing: "-3%", color: "black", lineHeight: "150%" },
});

export default Component08;